import { observer } from 'mobx-react'
import Navigation from '@App/navigation'
import React, { useContext } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import Button from '@Components/Buttons/Button'
import { useNavigate } from 'react-router'
import { FetchType } from '@Components/WorkItemV2/fetch-type-enum'
import { Maybe } from '@Types'
import createWizardFlow from '@App/stores/wizardFlow/create-wizard-flow'
import { WorkModel } from '@Entities/work/work'

interface CopyWorkButtonProps {
    workId: Maybe<number>
    work?: WorkModel
    type?: 'primary' | 'primary-small' | 'secondary' | 'secondary-small' | 'tertiary'
}

const CopyWorkButton = ({ workId, work, type = 'secondary' }: CopyWorkButtonProps) => {
    const navigate = useNavigate()
    const { workStore, rightsholderStore, wizardFlowStore } = useContext<RootStore>(StoresContext)

    if (!workId) {
        return null
    }

    const copyWork = async () => {
        let workToCopy: WorkModel
        if (work && work.id === workId) {
            workToCopy = work
        } else {
            await workStore.getWorkById(workId, FetchType.MLC)
            const workById = workStore.workById
            if (!workById) {
                return
            }
            workToCopy = workById
        }
        workStore.setWorkDraftToLocal({
            ...workToCopy,
            id: null,
            submissionId: null,
            masterTransactionId: undefined,
            localId: undefined,
            propertyId: null,
            submissionPropertyId: undefined,
            sesacSelectedPropertyId: undefined,
            originalSubmissionId: undefined,
            rightsholderProprietaryId: null,
            isComplete: false,
            recordings: [],
            matchedRecordings: null,
            iswc: null,
            createdDate: null,
            updateDate: null,
            lastUpdated: null,
            submissionDate: undefined,
            songCode: undefined,
            registrationHistoryStatus: null,
            registrationHistoryIndicator: null,
            registrationHistoryDate: null,
        })
        wizardFlowStore.setFlow(createWizardFlow(wizardFlowStore))
        wizardFlowStore.setCurrentIndex(wizardFlowStore.flowLength - 1)
        navigate(Navigation.rightholder.createWork.root(rightsholderStore.currentRightsholderId))
    }
    return (
        <Button mainColor type={type} className="next copy-button" onClick={copyWork}>
            Copy Work
        </Button>
    )
}

export default observer(CopyWorkButton)
